
import insertTopic from './insertTopic';

const insertTopicMenuConf = {
  key: 'insertTopic',
  factory() {
    return new insertTopic();
  },

  // 默认的菜单菜单配置，将存储在 editorConfig.MENU_CONF[key] 中
  // 创建编辑器时，可通过 editorConfig.MENU_CONF[key] = {...} 来修改
};

export { insertTopicMenuConf };
